import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Mohme from '../images/logomohme.png'
import LaRepublica from '../images/logolarepublica.png'

const useStyles = makeStyles(theme => ({
  footer: {
    background: '#fff'
  },
  footerContent: {
    maxWidth: '90%',
    padding: 10,
    margin: '0 auto',
    borderTop: '1px solid ' + theme.palette.grey[400]
  },
  footerText: {
    color: theme.palette.grey[700],
    maxWidth: 480,
    margin: '2em auto',
    textAlign: 'center'
  },
  img: {
    width: 200
  },
  footerImg: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  }
}))

const Footer = () => {
  const classes = useStyles()
  return (
    <footer className={classes.footer}>
      <div className={classes.footerContent}>
        <div className={classes.footerText}>
          <div className={classes.footerImg}>
            <img src={Mohme} alt="Fundación Mohme" className={classes.img} />
            <img src={LaRepublica} alt="La República" className={classes.img} />
          </div>
          <div>
            Proyecto Infraestructura Natural para la Seguridad Hídrica, en
            alianza con la Fundación Gustavo Mohme Llona.
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
